/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'slick-carousel';
import './rocketpager/app.js'